import { SKYNET_INTERNAL_COMPANY_ID } from 'app/auth/authRoles';
import _ from 'lodash';

import { TaskAssignmentType } from 'constants/tasks';

import { SKIP_FORBIDDEN } from './httpConfig';

const EMPTY_TASK_TYPE_FIELDS = {
  description: null,
  entityAssignmentType: null,
  taskCategoryId: null,
  documentTypeId: null,
  feeTypeId: null,
  metadataTemplate: null,
  action: null,
};

const getTaskTypesUrl = companyId => `/api/companies/${companyId}/taskTypes`;

export const toTaskType = (
  {
    id,
    isGlobal,
    slaGroupId = null,
    effectiveSlaGroupId = null,
    slaGroupOverride = null,
    ...taskType
  },
  companyId,
) => {
  const hasSlaGroupOverride =
    taskType.taskAssignmentType === TaskAssignmentType.SLA_GROUP && !_.isNil(slaGroupOverride);

  return {
    ...EMPTY_TASK_TYPE_FIELDS,
    ...taskType,
    taskTypeId: id,
    companyId: isGlobal ? SKYNET_INTERNAL_COMPANY_ID : companyId,
    slaGroupId: effectiveSlaGroupId,
    originalSlaGroupId: hasSlaGroupOverride ? slaGroupId : null,
    slaGroupOverride: hasSlaGroupOverride ? slaGroupOverride : null,
  };
};

export class TaskTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes({ companyId }) {
    const response = await this.#http.get(getTaskTypesUrl(companyId), {
      params: { applySubCompanyScope: true },
    });

    return { ...response, data: response.data.map(taskType => toTaskType(taskType, companyId)) };
  }

  async getType({ companyId, taskTypeId }) {
    const response = await this.#http.get(`${getTaskTypesUrl(companyId)}/${taskTypeId}`);

    return { ...response, data: toTaskType(response.data, companyId) };
  }

  async createType({ companyId, ...body }) {
    const response = await this.#http.post(getTaskTypesUrl(companyId), body);

    return { ...response, data: toTaskType(response.data, companyId) };
  }

  async editType({ companyId, taskTypeId, ...body }) {
    const response = await this.#http.put(
      `${getTaskTypesUrl(companyId)}/${taskTypeId}`,
      body,
      SKIP_FORBIDDEN,
    );

    return { ...response, data: toTaskType(response.data, companyId) };
  }

  async deleteType({ companyId, taskTypeId }) {
    return this.#http.delete(`${getTaskTypesUrl(companyId)}/${taskTypeId}`);
  }
}
